export default __webpack_public_path__ + "static/media/flag-seychelles.23fa2496.svg";